import { Link } from "@inertiajs/react";
import { useTheme } from "@/hooks/useTheme";
import { SunIcon } from "@/components/ui/icons/SunIcon";
import { MoonIcon } from "@/components/ui/icons/MoonIcon";
import { FlashBanner } from "@/components/ui/FlashBanner";
import { MimirRune } from "@/components/ui/MimirRune";
import { SkipLink } from "@/components/ui/SkipLink";

interface AuthLayoutProps {
  children: React.ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  const { dark, toggleDark } = useTheme();

  return (
    <div className="min-h-dvh bg-page-bg font-sans text-body transition-colors duration-500 flex flex-col">
      <SkipLink />

      <header className="flex items-center justify-between px-6 sm:px-8 py-5">
        <Link
          href="/"
          className="flex items-center gap-3 font-display text-base uppercase tracking-[0.34em] text-nav-logo hover:text-heading transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 rounded"
        >
          <MimirRune />
          Mímir
        </Link>
        <button
          onClick={toggleDark}
          className="flex items-center justify-center w-11 h-11 rounded-md text-nav-toggle hover:text-nav-toggle-hover transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2"
          aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
        >
          {dark ? <SunIcon /> : <MoonIcon />}
        </button>
      </header>

      <main
        id="main-content"
        tabIndex={-1}
        className="flex-1 flex items-center justify-center px-6 sm:px-8 py-12 outline-none"
      >
        {children}
      </main>

      <FlashBanner />
      <footer className="px-6 sm:px-8 py-6 text-center border-t border-border-footer">
        <p className="text-xs text-footer-text font-light">
          © {new Date().getFullYear()} Mimir Languages
        </p>
      </footer>
    </div>
  );
}
